// Attaching values sets to a client (prospect or shareowner).
// Before a Formative or demo firm user attaches a values set that advisors at another firm can already see, the
// server answers 409 with error 'cross_firm_screen_sets' and the sets and firms involved (YourStake/hub#3962). We show
// that and resend with confirm_cross_firm only if the user agrees.

const HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' };
const escapeHtml = text => String(text).replace(/[&<>"']/g, c => HTML_ESCAPES[c]);

export function confirmCrossFirmWithBuefy(buefy) {
  return warning => new Promise(resolve => {
    const sets = warning.screen_sets
        .map(s => `<li><b>${escapeHtml(s.name)}</b> (${escapeHtml(s.firms.join(', '))})</li>`)
        .join('');
    const clientFirms = warning.client_firms.length ?
      `<b>${escapeHtml(warning.client_firms.join(', '))}</b>` :
      'this client\'s advisors';
    buefy.dialog.confirm({
      title: 'Share values with another firm?',
      message: `<p>Advisors at another firm can already see:</p><ul>${sets}</ul>` +
        `<p>Attaching it to this client would also share it with ${clientFirms}.</p>`,
      confirmText: 'Attach anyway',
      type: 'is-warning',
      hasIcon: true,
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}

// send(extra) makes the request with extra fields merged into the body and returns the fetch Response.
// Returns that Response, or null if the user decided not to attach after the warning.
export async function withCrossFirmConfirm(send, confirm) {
  const response = await send({});
  if (response.status !== 409) return response;
  const warning = await response.clone().json().catch(() => null);
  if (warning?.error !== 'cross_firm_screen_sets') return response;
  if (!(await confirm(warning))) return null;
  return send({ confirm_cross_firm: true });
}

// PUT a client's values sets from a component with $root.$data.csrfToken and $buefy.
export function putClientScreenSets(vm, clientId, screenSets) {
  const segment = clientId.startsWith('prospect_') ? 'prospects' : 'portfolios';
  const send = extra => fetch(`/api/v1/${segment}/${clientId}/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': vm.$root.$data.csrfToken,
    },
    body: JSON.stringify({ screen_sets: screenSets, ...extra }),
  });
  return withCrossFirmConfirm(send, confirmCrossFirmWithBuefy(vm.$buefy));
}
